import React, { useEffect } from "react"
import { HelmetProvider, Helmet } from "react-helmet-async"
import { Router, Switch, useLocation } from "react-router-dom"
import { createBrowserHistory } from "history"
import Theme from "@4cplatform/elements/Global/Theme"
import Normalise from "@4cplatform/elements/Global/Normalise"
import GlobalStyles from "@4cplatform/elements/Global/GlobalStyles"
import { AuthProvider, AuthRoute } from "@4cplatform/elements/Auth"
import { TranslationsProvider } from "@4cplatform/elements/Translations"
import { ConfigProvider } from "@4cplatform/elements/Config"
import { PusherProvider } from "@4cplatform/elements/Api"
import { Page } from "@4cplatform/elements/Organisms"

import { StyledToastifyContainer } from "@4cplatform/elements/Alerts"

// Helpers
import CONFIG, { pusherConfig } from "./config"
import routes from "./config/routes"
import { getUserDashboard } from "./UI/Helpers"

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (window.scrollTo) window.scrollTo(0, 0)
    if (document.querySelector("#page-content") && document.querySelector("#page-content").scrollTo)
      document.querySelector("#page-content").scrollTo(0, 0)
  }, [pathname])

  return null
}

const App = () => (
  <ConfigProvider config={CONFIG}>
    <HelmetProvider>
      <TranslationsProvider>
        <Theme>
          <Normalise />
          <GlobalStyles />
          <Helmet titleTemplate="%s | 4C Platform" />
          <Router history={createBrowserHistory()}>
            <ScrollToTop />
            <AuthProvider>
              <PusherProvider {...pusherConfig}>
                <StyledToastifyContainer />
                <Page dashboardHelper={getUserDashboard}>
                  <Switch>
                    {routes.map(route => (
                      <AuthRoute key={route.path} {...route} />
                    ))}
                  </Switch>
                </Page>
              </PusherProvider>
            </AuthProvider>
          </Router>
        </Theme>
      </TranslationsProvider>
    </HelmetProvider>
  </ConfigProvider>
)

export default App
